import React, { Component } from "react";
import { Box, Typography, Avatar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import myStyles from "./Style";

class MessageHost extends Component {
  constructor(props) {
    super(props);
    this.scrollTB = this.scrollTB.bind(this);
    this.getMsgTime = this.getMsgTime.bind(this);
    this.chatEnd = React.createRef();
  }

  scrollTB() {
    this.chatEnd.current.scrollIntoView();
  }

  getMsgTime(timestamp) {
    let date = timestamp.toDate();
    let hours = date.getHours();
    let minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

    let AmOrPm = hours > 11 ? "pm" : "am";

    return `${hours % 12 || 12}:${minutes} ${AmOrPm}`;
  }

  componentDidMount() {
    this.scrollTB();
  }

  componentDidUpdate() {
    this.scrollTB();
  }

  render() {
    const { classes, messages, chatData, chaType, user } = this.props;
    return (
      <Box
        my={1}
        border="1px solid"
        borderColor="primary.main"
        flex={1}
        overflow="auto"
      >
        {messages &&
          chatData &&
          messages.map((message, index) =>
            message.type === "info" ? (
              <Box key={index} display="flex" justifyContent="center">
                <div className={classes.dateBox}>
                  <Typography align="center">{message.message}</Typography>
                </div>
              </Box>
            ) : (
              <Box
                maxWidth={{ xs: "calc(80% - 16px)", sm: "calc(65% - 16px)",md: "calc(50% - 16px)" }}
                mt={1}
                ml={message.senderEmail === user.email ? "auto" : "16px"}
                mr={message.senderEmail === user.email ? "16px" : "auto"}
                key={index}
                display="flex"
                justifyContent={
                  message.senderEmail === user.email ? "flex-end" : "flex-start"
                }
              >
                <Box maxWidth="100%" width="max-content" display="inline-block">
                  {chaType === "group" && (
                    <Box
                      display="flex"
                      alignItems="center"
                      flexDirection={
                        message.senderEmail === user.email
                          ? "row-reverse"
                          : "row"
                      }
                    >
                      <Avatar
                        style={{
                          width: "25px",
                          height: "25px",
                          margin: "5px",
                        }}
                        src={
                          chatData.membersInfo
                            ? chatData.membersInfo[message.senderId].ppURL
                            : ""
                        }
                      />

                      <Typography
                        align={
                          message.senderEmail === user.email ? "right" : "left"
                        }
                      >
                        {chatData.membersInfo &&
                          chatData.membersInfo[`${message.senderId}`].username}
                      </Typography>
                    </Box>
                  )}
                  {message.message && (
                    <Box
                      width="max-content"
                      maxWidth="100%"
                      mt={1}
                      p={1}
                      borderRadius={
                        message.senderEmail === user.email
                          ? "17px 3px 17px 17px"
                          : "3px 17px 17px 17px"
                      }
                      bgcolor={
                        message.senderEmail === user.email
                          ? "primary.main"
                          : "secondary.main"
                      }
                      key={index}
                      overflow="hidden"
                    >
                      <span className={classes.msgText}>{message.message}</span>
                      <span className={classes.msgTime}>
                        {this.getMsgTime(message.timestamp)}
                      </span>
                    </Box>
                  )}
                  {message.link && (
                    <Box
                      width="max-content"
                      maxWidth="100%"
                      mt={1}
                      p={1}
                      key={index}
                      overflow="hidden"
                    >
                      <Box height={{ xs: "100px", sm: "200px" }}>
                        <video
                          style={{ borderRadius: "5px", maxWidth: "100%", height:'100%',}}
                          src={message.link}
                          alt="GIF"
                          autoPlay
                          loop
                        />
                      </Box>
                      <span className={classes.msgTime}>
                        {this.getMsgTime(message.timestamp)}
                      </span>
                    </Box>
                  )}
                </Box>
              </Box>
            )
          )}

        <div className={classes.chatBottomDiv} ref={this.chatEnd} />
      </Box>
    );
  }
}

export default withStyles(myStyles)(MessageHost);
